import React, { useEffect, useRef } from 'react';

const TreeSvg = ({ connections }) => {
    const svgRef = useRef(null);

    useEffect(() => {
        const draw = () => {
            const svg = svgRef.current;
            if (!svg) return;

            const wrap = svg.parentElement;
            const wrapRect = wrap.getBoundingClientRect();

            svg.setAttribute('viewBox', `0 0 ${wrapRect.width} ${wrapRect.height}`);

            const paths = connections.map(({ fromId, toId, colorFrom, colorTo }) => {
                const fromEl = document.getElementById(fromId);
                const toEl = document.getElementById(toId);
                if (!fromEl || !toEl) return '';

                const fromRect = fromEl.getBoundingClientRect();
                const toRect = toEl.getBoundingClientRect();

                const x1 = fromRect.left - wrapRect.left + fromRect.width / 2;
                const y1 = fromRect.top  - wrapRect.top  + fromRect.height / 2;
                const x2 = toRect.left   - wrapRect.left + toRect.width / 2;
                const y2 = toRect.top    - wrapRect.top  + toRect.height / 2;

                const midY = (y1 + y2) / 2;
                const gradId = `grad-${fromId}-${toId}`;

                return `
                    <defs>
                        <linearGradient id="${gradId}" x1="${x1}" y1="${y1}" x2="${x2}" y2="${y2}" gradientUnits="userSpaceOnUse">
                            <stop offset="0%"   stop-color="${colorFrom}" />
                            <stop offset="100%" stop-color="${colorTo}" />
                        </linearGradient>
                    </defs>
                    <path
                        d="M ${x1} ${y1} C ${x1} ${midY}, ${x2} ${midY}, ${x2} ${y2}"
                        fill="none"
                        stroke="url(#${gradId})"
                        stroke-width="2"
                        stroke-linecap="round"
                    />
                `;
            }).join('');

            svg.innerHTML = paths;
        };

        // Attend que le DOM soit bien rendu
        const timer = setTimeout(draw, 100);

        window.addEventListener('resize', draw);
        return () => {
            clearTimeout(timer);
            window.removeEventListener('resize', draw);
        };
    }, [connections]);

    return (
        <svg
            ref={svgRef}
            style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                pointerEvents: 'none',
                overflow: 'visible'
            }}
        />
    );
};

export default TreeSvg;